import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Styled from 'src/components/Footer/Footer.styles';

const Footer = ({ className }) => {
  const { t } = useTranslation();

  return (
    <Styled.Footer className={className}>
     <Styled.Link to={{ pathname: 'https://www.elevatelimited.com/about-elevate/sustainability/privacy-policy/' }} target="_blank">
        {t('PRIVACY_POLICY')}
      </Styled.Link>
      <Styled.Link to={{ pathname: 'https://www.elevatelimited.com/about-elevate/sustainability/terms-conditions/' }} target="_blank">
        {t('TERMS_AND_CONDITIONS')}
      </Styled.Link> 
      <Styled.Link to={{ pathname: 'https://www.elevatelimited.com/about-elevate/contact/' }} target="_blank">
      {t('CONTACT')}
      </Styled.Link> 
    </Styled.Footer>
  )
};

Footer.propTypes = {
  className: PropTypes.string,
};

Footer.defaultProps = {
  className: null,
};

export default React.memo(Footer);
